import React from "react";
import "./CommonModal.css";

function CommonModal({
  onClose,
  title,
  children,
  footer = null,
  overlayClassName = "common-modal-overlay",
  contentClassName = "common-modal-content",
  headerClassName = "common-modal-header",
  bodyClassName = "common-modal-body",
  footerClassName = "common-modal-footer",
  closeButtonClassName = "common-modal-close",
  closeIcon = <i className="fas fa-times"></i>,
  showCloseButton = true,
  closeOnOverlayClick = true,
  closeOnEscape = true,
  titleAs: TitleTag = "h5",
}) {
  React.useEffect(() => {
    if (!closeOnEscape || !onClose) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [closeOnEscape, onClose]);

  return (
    <div
      className={overlayClassName}
      onClick={closeOnOverlayClick ? onClose : undefined}
    >
      <div className={contentClassName} onClick={(event) => event.stopPropagation()}>
        {(title || showCloseButton) && (
          <div className={headerClassName}>
            {title ? <TitleTag>{title}</TitleTag> : <span></span>}
            {showCloseButton ? (
              <button
                type="button"
                className={closeButtonClassName}
                onClick={onClose}
              >
                {closeIcon}
              </button>
            ) : null}
          </div>
        )}
        <div className={bodyClassName}>{children}</div>
        {footer ? <div className={footerClassName}>{footer}</div> : null}
      </div>
    </div>
  );
}

export default CommonModal;
